var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("avatar-container avatar-container-" + _vm.size)},[_c('img',{class:("avatar avatar-" + _vm.size),attrs:{"src":_vm.imageSource}})])}
var staticRenderFns = []

export { render, staticRenderFns }